import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureBlobReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-blob-read-settings';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FilePathMode } from 'app/registries/consts/metadata-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        prefix: '*'
    }
})
export class AzureBlobStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    AzureBlobReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<AzureBlobReadSettings> {
        const blobModel = await super._toModel(resource, copySource);
        if (resource.prefix) {
            ValueAdapter.toModel(blobModel, AzureBlobReadSettings.PREFIX, resource.prefix);
            blobModel.filePathMode = FilePathMode.PREFIX;
        }
        ValueAdapter.toModel(
            blobModel,
            AzureBlobReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );
        return blobModel;
    }

    protected override async _toResource(settings: AzureBlobReadSettings): Promise<Model.StoreReadSettings> {
        const blobResource = await super._toResource(settings);
        if (blobResource != null) {
            if (settings.filePathMode === FilePathMode.PREFIX) {
                blobResource.prefix = ValueAdapter.toResource(settings, AzureBlobReadSettings.PREFIX) || undefined;
                blobResource.wildcardFileName = blobResource.wildcardFolderPath = undefined;
            } else if (settings.filePathMode === FilePathMode.WILDCARD) {
                blobResource.prefix = undefined;
            } else {
                blobResource.prefix = undefined;
                blobResource.wildcardFileName = blobResource.wildcardFolderPath = undefined;
            }
            blobResource.deleteFilesAfterCompletion = ValueAdapter.toResource(
                settings,
                AzureBlobReadSettings.DELETE_FILE_AFTER_COMPLETION
            );
        }
        return blobResource;
    }
}
